export default {"src":"/_next/static/media/training-info.1f133bb5.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};